import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-938b435e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "video-container" }
const _hoisted_4 = {
  key: 0,
  class: "video-wrapper"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "not_frame"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Consulta la fecha de inicio"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" en nuestra sección de Bootcamps")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "session-cards" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "session-card-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/bootcamp" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "btn-back" }, "Volver Atrás")
  ])
], -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "descriptions"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ProdevValidator from '@/components/auth/ProdevValidator.vue';
import BootCampService from '@/services/BootCampService';
import { useRoute } from 'vue-router';
import SelectedI from '@/interfaces/SelectedInterface'
//import BootCampsDetailsI from '@/interfaces/BootCampDetailsInterface';
import { Ref,ref,onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BootCampsDetailsView',
  setup(__props) {

const loading:Ref<boolean> =ref(false)
const route = useRoute()
const service = new BootCampService()
const bootcamp_detail:Ref<SelectedI[]> = ref([])
const selectedObject:Ref<SelectedI> = ref({})
const selectedSessionIndex:Ref<number | undefined> = ref(0)

onMounted(async()=>{
  loading.value = true;
  bootcamp_detail.value = await service.GetBootCampDetail(route?.params?.id)
  selectedSessionIndex.value = 0;
  selectedObject.value = bootcamp_detail.value[selectedSessionIndex.value];
  loading.value = false;

})

const description = ref(false);

const toggleDescription = (index: number | undefined) => {
  if (selectedSessionIndex.value !== index) {
    description.value = true;
    selectedSessionIndex.value = index;
    if(selectedSessionIndex.value != undefined){
    selectedObject.value = bootcamp_detail.value[selectedSessionIndex.value];}
  } else {
    description.value = !description.value;
  }
};

const closeDescription = () => {
  description.value = false;
};


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(ProdevValidator),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (selectedObject.value?.src)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("iframe", {
                  src: selectedObject.value?.src,
                  frameborder: "0",
                  allow: "autoplay; fullscreen; picture-in-picture; clipboard-write",
                  title: "Bootcamp Spring - Sesión 0"
                }, null, 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bootcamp_detail.value, (elm) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "session-card",
              key: elm?.id,
              onClick: ($event: any) => (toggleDescription(elm?.order))
            }, [
              _createElementVNode("h2", null, _toDisplayString('Sesión ' + elm?.order), 1)
            ], 8, _hoisted_12))
          }), 128))
        ]),
        (description.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("h2", null, _toDisplayString('Sesión ' + selectedSessionIndex.value), 1),
              _hoisted_15,
              (selectedSessionIndex.value != undefined)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(Object.values(bootcamp_detail.value)[selectedSessionIndex.value]?.description), 1))
                : _createCommentVNode("", true),
              _hoisted_17,
              _createElementVNode("button", {
                onClick: closeDescription,
                class: "close"
              }, "Cerrar")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})